import BaseApi from "./base_api";

export default class SimpleApi {
  static get(path, params = {}) {
    return BaseApi.get(path, params).then(response => response.json());
  }

  static post(path, body = {}, options = {}) {
    return BaseApi.post(path, body, options).then(response => response.json());
  }

  static put(path, body = {}) {
    return BaseApi.put(path, body).then(response => response.json());
  }

  static patch(path, body = {}) {
    return BaseApi.patch(path, body).then(response => response.json());
  }

  static delete(path) {
    return BaseApi.delete(path).then(response => response.json());
  }
}
